"use client"

import imageOne from "images/about/marquee/Marquee1.png"
import imageTwo from "images/about/marquee/Marquee2.png"
import imageThree from "images/about/marquee/Marquee3.png"
import { InfiniteSideScroll } from "library/InfiniteSideScroll"
import StaticImage from "library/StaticImage"
import { css, f, styled } from "library/styled"
import { useMedia } from "library/useMedia"
import { Fragment } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function Marquee() {
	const marqueeSpeed = useMedia(0.4, 0.4, 0.3, 0.2)
	const marqueeText = "Healthcare With You in Mind"
	const marqueeItems = [
		{ id: 1, text: marqueeText, image: imageOne, alt: "Marquee Image 1" },
		{ id: 2, text: marqueeText, image: imageTwo, alt: "Marquee Image 2" },
		{ id: 3, text: marqueeText, image: imageThree, alt: "Marquee Image 3" },
	]

	return (
		<Wrapper>
			<MarqueeWrapper marqueeSpeed={marqueeSpeed} disableDrag>
				{marqueeItems.map((item) => (
					<Fragment key={item.id}>
						<MarqueeItem>
							<MarqueeText>{item.text}</MarqueeText>
						</MarqueeItem>
						<MarqueeImage src={item.image} alt={item.alt} />
					</Fragment>
				))}
			</MarqueeWrapper>
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...f.responsive(css`
		position: relative;
		width: 1440px;
		margin: 0 auto;
		user-select: none;
	`),
	...f.tablet(css`
		width: 1024px;
	`),
	...f.mobile(css`
		width: 375px;
	`),
})

const pseudoElementBase = css`
	content: "";
	position: absolute;
	z-index: 2;
	top: 50%;
	transform: translateY(-50%);
	height: 192px;
`

const MarqueeWrapper = styled(InfiniteSideScroll, {
	...f.responsive(css`
		padding: 140px 0;
		overflow: clip;

		&::before {
			${pseudoElementBase};
			left: 0;
			width: 200px;
			background: linear-gradient(
				270deg,
				rgba(251 250 246 / 0%) 0%,
				#fbfaf6 85.03%
			);
		}

		&::after {
			${pseudoElementBase};
			right: 0;
			width: 210px;
			background: linear-gradient(
				90deg,
				rgba(251 250 246 / 0%) 0%,
				#fbfaf6 84.42%
			);
		}
	`),
	...f.tablet(css`
		padding: 115px 0;
	`),
	...f.mobile(css`
		padding: 68px 0;

		&::before {
			width: 110px;
			height: 196px;
		}

		&::after {
			width: 110px;
			height: 196px;
		}
	`),
})

const MarqueeItem = styled("div", {
	...f.responsive(css`
		display: flex;
		align-items: center;
		position: relative;
		z-index: 1;
	`),
})

const MarqueeText = styled("p", {
	...f.responsive(css`
		${textStyles.h1};
		color: ${colors.green400};
	`),
	...f.mobile(css`
		${textStyles.h6};
	`),
})

const MarqueeImage = styled(StaticImage, {
	...f.responsive(css`
		width: 159px;
		height: 90px;
		margin: 0 24px;
		border-radius: 12px;
	`),
	...f.mobile(css`
		width: 78px;
		height: 44px;
		border-radius: 8px;
	`),
})
